import React, { useEffect, useState } from "react";
import "./FixDataFilterSelector.scss";
import { CircularProgress, FormControl, MenuItem, Select } from "@mui/material";
import { CommonEnums } from "../../../../enums/common.enums";
import CloseIcon from "../../../../components/icons/CloseIcon";
import DownArrowIcon from "../../../../components/icons/DownArrowIcon";

// let listData: any[] = [];
const FixDataFilterSelector = ({
  formik,
  type,
  placeholder,
  customData = [],
}: {
  formik: any;
  type: string;
  placeholder: string;
  customData?: any[];
}) => {
  let listData: any[] = [];
  //   const [state, setState] = useState({
  //     isLoading: false,
  //     listData: [],
  //     agentListBox: false,
  //   });

  const onClickRemove = () => {
    formik.setFieldValue(type, "");
  };

  switch (type) {
    case CommonEnums?.selectorType?.status:
      listData = [
        {
          id: CommonEnums.agencyEmployeeStatus?.active?.key,
          itemName: CommonEnums.agencyEmployeeStatus?.active?.value,
        },
        {
          id: CommonEnums.agencyEmployeeStatus?.deactivated?.key,
          itemName: CommonEnums.agencyEmployeeStatus?.deactivated?.value,
        },
        {
          id: CommonEnums.agencyEmployeeStatus?.archived?.key,
          itemName: CommonEnums.agencyEmployeeStatus?.archived?.value,
        },
      ];
      break;
  }

  return (
    <div className="user-status-contain">
      <p className="user-status-head">{placeholder}</p>
      <FormControl fullWidth className="user-filter-selector">
        {!formik?.values[type] && (
          <div className="user-status-placeholder">
            <p>{`Select ${placeholder}`}</p>
          </div>
        )}

        <div className={`filter-down-arrow-icon `}>
          {formik?.values[type] ? (
            <div
              className="reporting-manager-close-icon"
              onClick={onClickRemove}
            >
              <CloseIcon />
            </div>
          ) : (
            <div>
              <DownArrowIcon />
            </div>
          )}
        </div>
        <Select
          labelId="demo-simple-select-label"
          onChange={formik?.handleChange}
          name={type}
          value={formik?.values[type]}
          // IconComponent={state?.isLoading ? LoadingIcon : KeyboardArrowDownIcon}
          // inputComponent={DisableBtn}
          disabled={formik?.values[type] ? true : false}
          MenuProps={{
            disablePortal: true,
            classes: {
              paper: "selector-menu-container",
            },
          }}
        >
          {listData?.length ? (
            listData?.map((data: any) => (
              <MenuItem value={data?.id} key={data?.id}>
                {data?.itemName}
              </MenuItem>
            ))
          ) : (
            <div className="role-list-not-found">
              <p>Type not found!</p>
            </div>
          )}
        </Select>
      </FormControl>
    </div>
  );
};

export default FixDataFilterSelector;
